import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getProceedingCounts, getProceedingsItems } from "../../services/AppService";
import CardComponent from "../../components/CardComponent";

const Proceedings = () => {
   const [cards, setCards] = useState([]);
    const [counts, setCounts] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch items and counts in parallel for performance
                const [items, countData] = await Promise.all([
                    getProceedingsItems(),
                    getProceedingCounts()
                ]);
                setCards(items);
                setCounts(countData || {});
            } catch (error) {
                console.error('Error fetching dashboard data', error);
            }
        };
        fetchData();
    }, []);

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 justify-items-center">
            {cards.map((card, index) => (
                <CardComponent
                    key={index}
                    imgSrc={card.image}
                    title={card.title}
                    translationKey={card.translationKey}
                    // Pass the specific count based on the key
                    count={card.countKey ? counts[card.countKey] : null}
                    onClick={() => navigate(card.link || '/')}
                />
            ))}
        </div>
    );
}

export default Proceedings;